import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';

interface GetAllDepartmentsParams {
  page?: number;
  pageSize?: number;
  searchData?: {
    enabled?: boolean | string
  }
};

interface GetAllDepartmentsResponse {
  count: number;
  rows: [];
};

interface CreateUpdateDepartmentParams {
  name?: string;
};

interface GetAllDepartmentsResponse {
  count: number;
  rows: [];
};

interface CommonResponse {
  data:{}
};

class DepartmentAPI {

  async getAllDepartments(params: GetAllDepartmentsParams, entityId: string): Promise<GetAllDepartmentsResponse> {
    const jwt = localStorage.getItem('access-token');

    const queryParams: Record<string, string> = {};

    if (params.page !== undefined && params.pageSize !== undefined) {
      queryParams.offset = (params.page * params.pageSize).toString();
      queryParams.limit = params.pageSize.toString();
    }

    if (params.searchData) {
      Object.entries(params.searchData).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams[key] = value.toString();
        }
      });
    }

    if (params.enabled !== undefined && params.enabled !== null) {
      queryParams.enabled = String(params.enabled);
    }
    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/entity/${entityId}/departments?${queryString}` : `/api/entity/${entityId}/departments`;

    const res: AxiosResponse = await makeAPIRequest({
      method: 'GET',
      url: url,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    return res.data.data;
  };

  async getAllDepartmentsWithoutPagination(entityId: string): Promise<GetAllDepartmentsResponse> {
    const jwt = localStorage.getItem('access-token');
    const res: AxiosResponse = await makeAPIRequest({
      method: 'GET',
      url: `/api/entity/${entityId}/departments`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    return res.data.data;
  };

  async createDepartment(data: CreateUpdateDepartmentParams, entityId: string): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/entity/${entityId}/department`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async updateDepartment(departmentId: string, data: CreateUpdateDepartmentParams): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/department/${departmentId}`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async enabledDisabledDepartment(departmentId: string, data: { enabled: boolean }): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/department/${departmentId}/activateOrDeactivateDepartment`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async removeDepartment(departmentId: string): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'DELETE',
      url: `/api/department/${departmentId}`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

}

const departmentApi = new DepartmentAPI();
export default departmentApi;